import { type RequestOptions } from '@direct-frontend/modules-request';
import { request } from '../request';

export const transport = async <Result = unknown>(options: RequestOptions<Result, unknown>): Promise<Result> =>
    (await request(options)).data;
